import React from 'react';
import { Box } from '@mui/material';
import RelatedSectionShell, { TilesGrid } from './RelatedSectionShell';

// Use the same tile component you render on the dashboard for situations.
// If your project names it differently, adjust this import name/path:
import SituationTile from '../tiles/SituationTile';

import SituationsTable from './tables/SituationsTable';

const findSituationsSection = (sections) =>
  (sections || []).find((s) =>
    s?.title && /what are the top situations for doing this job/i.test(String(s.title))
  ) || null;

const sectionTotalFrom = (sec) =>
  sec?.section_total_interviews ?? sec?.sectionTotal ?? 0;

export default function RelatedSituations({ sections, customerStories = [], jobName }) {
  const situationsSec = React.useMemo(() => findSituationsSection(sections), [sections]);
  if (!situationsSec) return null;

  const tiles = Array.isArray(situationsSec.tiles) ? situationsSec.tiles : [];
  const top3 = tiles.slice(0, 3);

  return (
    <RelatedSectionShell section={situationsSec}>
      {/* Top-3 tiles (same visuals as dashboard) */}
      <Box sx={{ mb: 2 }}>
        <TilesGrid
          tiles={top3}
          renderTile={(t) => (
            <SituationTile {...t} sectionTotal={sectionTotalFrom(situationsSec)} />
          )}
        />
      </Box>

      {/* Full ranked table with expandable per-interview rows */}
      <SituationsTable
        rowsSource={tiles}
        customerStories={customerStories}
        jobName={jobName}
      />
    </RelatedSectionShell>
  );
}
